<template>
  <IconBase
    :width="iconSize"
    :height="iconSize"
    :view-box="`0 0 40 40`"
    icon-color="transparent"
  >
    <component
      :is="iconComponent"
      :icon-color="iconColor"
      :bg-color="bgColor"
    />
  </IconBase>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import IconBase from "@/common/components/atoms/IconBase.vue";

import IconInvestedRoundedType1 from "@/common/components/icons/IconInvestedRoundedType1.vue";
import IconInvestedRoundedType2 from "@/common/components/icons/IconInvestedRoundedType2.vue";
import IconInvestedRoundedType3 from "@/common/components/icons/IconInvestedRoundedType3.vue";
import IconInvestedRoundedType4 from "@/common/components/icons/IconInvestedRoundedType4.vue";
import IconInvestedRoundedType5 from "@/common/components/icons/IconInvestedRoundedType5.vue";
import IconInvestedRoundedType6 from "@/common/components/icons/IconInvestedRoundedType6.vue";
import IconInvestedRoundedType7 from "@/common/components/icons/IconInvestedRoundedType7.vue";
import IconInvestedRoundedType8 from "@/common/components/icons/IconInvestedRoundedType8.vue";
import IconInvestedRoundedType9 from "@/common/components/icons/IconInvestedRoundedType9.vue";
import IconInvestedRoundedType10 from "@/common/components/icons/IconInvestedRoundedType10.vue";
import IconInvestedRoundedType11 from "@/common/components/icons/IconInvestedRoundedType11.vue";
import IconInvestedRoundedType12 from "@/common/components/icons/IconInvestedRoundedType12.vue";

@Options({
  props: {
    iconSize: { type: Number, default: 135 },
    type: { type: Number || String, default: 1 },
    iconColor: { type: String, default: "#ffffff" },
    bgColor: { type: String, default: "#ee1c25" }
  },
  components: {
    IconBase,
    IconInvestedRoundedType1,
    IconInvestedRoundedType2,
    IconInvestedRoundedType3,
    IconInvestedRoundedType4,
    IconInvestedRoundedType5,
    IconInvestedRoundedType6,
    IconInvestedRoundedType7,
    IconInvestedRoundedType8,
    IconInvestedRoundedType9,
    IconInvestedRoundedType10,
    IconInvestedRoundedType11,
    IconInvestedRoundedType12
  }
})
export default class IconInvestedRounded extends Vue {
  iconSize!: number;
  type!: number | string;
  iconColor!: string;
  bgColor!: string;

  get iconComponent() {
    const { type } = this;
    return `IconInvestedRoundedType${type}`;
  }
}
</script>
